import React, { Component } from 'react';
import './styles/SidePanel.css';

export default class SidePanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            curView: null,
            byLangNews: null,
            byCountryNews: null
        }

        this.casesChartOpen = false;
        this.deathsChartOpen = false;
        this.testsChartOpen = false;
    }

    handleChartsClick = (e) => {
        e.preventDefault();
        this.setState({
            curView: "charts"
        });
        if(this.state.curView === 'charts') {
            this.setState({
                curView: ""
            });
            document.getElementById("side-panel-tabs").style.display = 'flex';
            document.getElementById("side-panel-outer-wrapper").style.background = "none";
            document.getElementById("side-panel-outer-wrapper").style.boxShadow = "none";
            document.getElementById("left-sidebar").style.zIndex = "350";

        }
        else {
            document.getElementById("side-panel-tabs").style.display = 'none';
            document.getElementById("left-sidebar").style.width = "50vw";
            document.getElementById("side-panel-outer-wrapper").style.background = "#FAFAFA";
            document.getElementById("side-panel-outer-wrapper").style.boxShadow = "0 4px 8px 0 rgba(0,0,0,.2)";
            document.getElementById("left-sidebar").style.zIndex = "700"

        }
    }
    handleCasesClick = (e) => {
        e.preventDefault();
        this.casesChartOpen ? document.getElementById("cases-charts-list").style.display = "none" : document.getElementById("cases-charts-list").style.display = "block";
        this.casesChartOpen = !this.casesChartOpen;
    }
    handleDeathsClick = (e) => {
        e.preventDefault();
        this.casesChartOpen ? document.getElementById("deaths-charts-list").style.display = "none" : document.getElementById("deaths-charts-list").style.display = "block";
        this.casesChartOpen = !this.casesChartOpen;
    }
    handleTestsClick = (e) => {
        e.preventDefault();
        this.casesChartOpen ? document.getElementById("tests-charts-list").style.display = "none" : document.getElementById("tests-charts-list").style.display = "block";
        this.casesChartOpen = !this.casesChartOpen;
    }

    handlePanelClose = (e) => {
        e.preventDefault();
        this.setState({
            curView: ""
        });
        document.getElementById("side-panel-tabs").style.display = 'flex';
        document.getElementById("side-panel-outer-wrapper").style.background = 'none';
        document.getElementById("side-panel-outer-wrapper").style.boxShadow = 'none';
        // document.getElementById("side-panel-inner-content").style.display = "none";
        // document.getElementById("left-sidebar").style.display = "inline-block";
        document.getElementById("left-sidebar").style.width = "0";
    }


    render() {
        return (
            <div id="side-panel-outer-wrapper">
                <div id="side-panel-tabs">
                    <span id="charts-tab" className='side-panel-tab-item tab-allowed' onClick={this.handleChartsClick}>
                        Charts
                        <span className='item-tooltip'>Coming soon</span>
                    </span>
                    <span id="slider-tab" className='side-panel-tab-item tab-not-allowed'>
                        Slider
                        <span className='item-tooltip'>Coming soon</span>
                    </span>
                    <span id="news-tab" className='side-panel-tab-item tab-not-allowed'>
                        News
                        <span className='item-tooltip'>Coming soon</span>
                    </span>
                </div>

                <div id="side-panel-inner-content">
                    {this.state.curView ? <span id="opened-side-xout" onClick={this.handlePanelClose}>&#10006;</span> : ""}
                    
                    {
                        this.state.curView ?
                            <div id="opened-side-content-nav">
                                <span className={this.state.curView === "charts" ? "opened-side-content-allowed selected-chart": "opened-side-content-allowed"}>
                                    Charts
                                </span>
                                <span className="opened-side-content-not-allowed">
                                    Slider
                                </span>
                                <span className="opened-side-content-not-allowed">
                                    News
                                </span>
                            </div>
                        :
                        ""
                    }
                    {
                        this.state.curView === "charts" ? 

                        <div id="charts" className="side-panel-inner-details">
                            <div className="chart-item">
                                <span className="chart-dropdown-btn" onClick={this.handleCasesClick}>Cases</span>
                                <div className="charts-list" id="cases-charts-list" >
                                    <iframe src="https://ourworldindata.org/grapher/daily-cases-covid-19">
                                    </iframe>
                                    <iframe src="https://ourworldindata.org/grapher/total-cases-covid-19">
                                    </iframe>
                                    <iframe src="https://ourworldindata.org/grapher/covid-confirmed-cases-since-100th-case">
                                    </iframe>
                                </div>
                            </div>

                            <div className="chart-item">
                                <span className="chart-dropdown-btn" onClick={this.handleDeathsClick}>Deaths</span>
                                <div className="charts-list" id="deaths-charts-list">
                                    <iframe src="https://ourworldindata.org/grapher/daily-deaths-covid-19">
                                    </iframe>
                                    <iframe src="https://ourworldindata.org/grapher/total-deaths-covid-19" >
                                    </iframe>
                                    <iframe src="https://ourworldindata.org/grapher/covid-confirmed-deaths-since-5th-death">
                                    </iframe>
                                </div>
                            </div>

                            <div className="chart-item">
                                <span className="chart-dropdown-btn" onClick={this.handleTestsClick}>Testing</span>
                                <div className="charts-list" id="tests-charts-list">
                                    <iframe src="https://ourworldindata.org/grapher/number-of-covid-19-tests-per-confirmed-case-bar-chart"></iframe>
                                    <iframe src="https://ourworldindata.org/grapher/full-list-cumulative-total-tests-per-thousand"></iframe>
                                    <iframe src="https://ourworldindata.org/grapher/daily-covid-19-tests-per-thousand-rolling-3-day-average"></iframe>
                                </div>
                            </div>
                        </div>

                        :

                        ""
                    }
                    {
                        this.state.curView === "news" ?

                        "news coming soon"

                        :

                        ""
                    }
                </div>
            </div>
        )
    }
}